import React, { memo } from "react";
import { Modal, ModalHeader, ModalBody, Col, Row } from "reactstrap";
import { Divider, Tabs } from "antd";
import DailyTab from "./Tabs/DailyTab";
// import GraphicalTab from "./Tabs/GraphicalTab";
import EventsTab from "./Tabs/EventsTab";
import { useSelector } from "react-redux";
import LastDataTab from "./Tabs/LastDataTab";
import moment from "jalali-moment";

const { TabPane } = Tabs;

const ModalPanel = ({
  loadingDailyChart,
  powerOptimizer,
  lastProduction,
  showModal,
  setShowModal,
  sliderChartData,
  dailyChartData,
  setDateHOC,
  dateHOC,
  events,
  count,
  setRefresh,
  serial_number
}) => {
  const lang_choiced = useSelector((state) => state.lang_change);


  // console.log(dailyChartData, lastProduction, "is lastProduction");
  return (
    <Modal
      style={{ minWidth: "90%" }}
      isOpen={showModal}
      toggle={() => setShowModal(false)}
    >
      <ModalHeader toggle={() => setShowModal(false)}>
        {lang_choiced.pages.byPanel.Modal.title} :
        <span className="text-muted ml-2 mr-2 text-sm-center">
          ({serial_number ? `${serial_number}` : "-"})
        </span>
        <br />
        <span className="text-muted mr-2 ml-2" style={{ fontSize: "13px" }}>
          {lang_choiced.pages.byPanel.Modal.LastProdTime}
          {lastProduction
            ? `${Math.ceil(
              (new Date().getTime() - lastProduction?.date_time) / 1000
            )} ثانیه قبل`
            : "-"}
        </span>
      </ModalHeader>
      <div className="string-label-bypanel">
        <Row className="content-label-bypanel smaller-font">
          <Col className="col-xs-12-bypanel smaller-font col-sm-3 col-md-3 col-lg-3 col-xl-3 ">
            {lang_choiced.pages.byPanel.Modal.Ppanel} :{" "}
            <span className="mr-1">W</span>
            <span style={{ unicodeBidi: "plaintext" }}>
              {lastProduction?.Vpv && lastProduction?.Ipv
                ? Math.abs(
                  (
                    (Math.round(lastProduction.Vpv) / 100) *
                    (Math.round(lastProduction.Ipv) / 1000)
                  ).toFixed(0)
                )
                : "-"}
            </span>
          </Col>

          {/* <Col className="col-xs-12-bypanel  smaller-font col-sm-3 col-md-3 col-lg-3 col-xl-3 b-r-2 b-l-2 none-sm-border">
            جریان :{" "}
            {lastProduction
              ? (Math.round(lastProduction.Ipv) / 1000).toFixed(2)
              : "-"}<span className="mr-2">A</span>
          </Col> */}

          <Col className="col-xs-12-bypanel  smaller-font col-sm-3 col-md-3 col-lg-3 col-xl-3 b-r-2  b-l-2 none-sm-border">
            <div>
              <span> {lang_choiced.pages.byPanel.Modal.Pbat} : </span>
              <span className="mr-1">W</span>
              <span style={{ unicodeBidi: "plaintext" }}>
                {lastProduction?.Vbat && lastProduction?.Ibat
                  ? (
                    (Math.round(lastProduction.Vbat) / 100) *
                    (Math.round(lastProduction.Ibat) / 1000)
                  ).toFixed(0)
                  : "-"}
              </span>
            </div>
          </Col>
          <Col className="col-xs-12-bypanel  smaller-font col-sm-3 col-md-3 col-lg-3 col-xl-3 none-sm-border ">
            {lang_choiced.pages.byPanel.Modal.Epanel} :{" "}
            <span className="ltr">
              {lastProduction?.Ein ? lastProduction.Ein : "-"}
            </span>
            <span className="mr-1">Wh</span>
          </Col>
          <Col
            className={`col-xs-12-bypanel smaller-font col-sm-3 col-md-3 col-lg-3 col-xl-3 ${window.document.documentElement.lang === "fa" ? "b-r-2" : "b-l-2"
              } `}
          >
            {lang_choiced.pages.byPanel.Modal.BatteryCharge} :{" "}
            <span className="ltr">
              {lastProduction?.SOC
                ? lastProduction.SOC / 100 > 100
                  ? 100
                  : (lastProduction.SOC / 100).toFixed(0)
                : "-"}
            </span>
            <span className="mr-1">%</span>
          </Col>
        </Row>
      </div>
      <ModalBody>
        <Tabs defaultActiveKey="1" type="card">
          <TabPane
            tab={
              lang_choiced.pages.byPanel.PanelGroup.Line.Modal.lastDataTab.title
            }
            key="1"
          >
            <LastDataTab lastData={lastProduction} />
          </TabPane>

          {/* <TabPane
            tab={lang_choiced.components.ByPanel.Panels.ModalPanel.page2}
            key="2"
          >
            <GraphicalTab
              powerOptimizer={powerOptimizer}
              sliderChartData={sliderChartData}
              setDateHOC={(date) => setDateHOC(date)}
              dateHOC={dateHOC}
            />
          </TabPane> */}
          <TabPane
            tab={
              lang_choiced.pages.byPanel.PanelGroup.Line.Modal.chartTab.title
            }
            key="4"
          >
            <DailyTab
              loadingDailyChart={loadingDailyChart}
              powerOptimizer={powerOptimizer}
              dailyChartData={dailyChartData}
              setDateHOC={(date) => setDateHOC(date)}
              dateHOC={dateHOC}
              setRefresh={() => setRefresh()}
              lang_choiced={lang_choiced}
            />
          </TabPane>
          <TabPane
            tab={
              lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.title
            }
            key="3"
          >
            <EventsTab
              powerOptimizer={powerOptimizer}
              events={events}
              dateHOC={dateHOC}
              // setDateHoc={(date) => console.log(date)}
              count={count}
            />
          </TabPane>


        </Tabs>
      </ModalBody>
    </Modal>
  );
};

export default memo(ModalPanel);
